import { experiment } from "@faire/web--source/common/settings/declarations/experiment";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

/**
 * Logged out nav mobile web update
 */
export const FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402 = experiment({
  name: "FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-06-01",
  defaultValue: IFourVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
